import { __assign } from "tslib";
import React from 'react';
import classnames from 'classnames';
import { useFlag } from '../../../../redux/flags/hooks';
import ErrorBoundary from '../../../../ErrorBoundary';
import DeviationDumbView from '../../../Dumbo';
import DeviationLink from '../../../../Duperbrowse/DeviationLink';
import { DeviationTypes } from '../../../../types/deviation';
import Overlay from '../Overlay';
import { BiDataHook } from '../../../../biLogger/constants';
import { getDeviationType } from '../../../_helpers';
import s from './Default.scss';
import overlayHelperStyles from '../OverlayHelpers.scss';
var Default = function (_a) {
    var className = _a.className, deviation = _a.deviation, height = _a.height, responsive = _a.responsive, style = _a.style, width = _a.width, extraActions = _a.extraActions;
    var hasSeoFlag = useFlag('seo_thumbs');
    var type = getDeviationType(deviation);
    var linkAsWrapper = hasSeoFlag && type === DeviationTypes.IMAGE;
    return (React.createElement("div", { className: classnames(s['root'], overlayHelperStyles['hoverable'], className), style: __assign({ width: width, height: height }, style), "data-hook": BiDataHook.DEVIATION_STD_THUMB },
        React.createElement(ErrorBoundary, null,
            linkAsWrapper ? (React.createElement(DeviationLink, { deviation: deviation, "aria-hidden": true, tabIndex: -1 },
                React.createElement(DeviationDumbView, { deviation: deviation, width: width, height: height, responsive: responsive }))) : (React.createElement(React.Fragment, null,
                React.createElement(DeviationDumbView, { deviation: deviation, width: width, height: height, responsive: responsive }),
                React.createElement(DeviationLink, { deviation: deviation, className: s['link-overlay'], title: deviation.title, "aria-label": deviation.title },
                    React.createElement("span", null)))),
            React.createElement(Overlay, { deviation: deviation, width: width, height: height, extraActions: extraActions, className: s['overlay'] }))));
};
Default.displayName = 'Default';
export default Default;
//# sourceMappingURL=Default.js.map